import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { connect } from 'react-redux';
import { compose } from 'utils/react';
import useQuery from '../../../../modules/react/hooks/useQuery';
import Component from 'components/FacilitiesList';
import { getPageLocale } from '../../store/modules/page';
import { getPageLocale as getPageBuilderLocale } from '../../store/modules/pageBuilder';
import { BUILDER } from 'shared/abilities';

const GET_FACILITIES = gql`
  query GetFacilities($live: Boolean!, $locale: String!) {
    facilities(filter: { live: $live, locale: $locale }) {
      edges {
        node {
          id
          ...FacilitiesListFacility
        }
      }
    }
  }

  ${Component.fragments.facility}
`;

const propTypes = { locale: PropTypes.string.isRequired };

const FacilitiesList = ({ locale }) => {
  const { data, error, loading } = useQuery(
    GET_FACILITIES,
    { variables: { live: true, locale } },
  );

  if (error || loading) {
    return null;
  }

  const facilities = data.facilities.edges.map(({ node }) => node);

  return <Component facilities={facilities} />;
};

FacilitiesList.propTypes = propTypes;

const container = compose(
  connect(
    state => ({
      locale: getPageLocale(state) || getPageBuilderLocale(state),
    }),
  ),
)(FacilitiesList);

container.authorization = { action: 'manage', subject: BUILDER };

export default container;
